import {all, fork} from "redux-saga/effects";
import initializationSaga from "./initialization";
import actionSaga from "./actions";
import userSaga from "./user";
import filterSaga from "./filtering";

function* userAdminSaga(){
  yield all([
    fork(initializationSaga),
    fork(actionSaga),
    fork(userSaga),
    fork(filterSaga)
  ])
}
export default userAdminSaga;
